import { Container, Image, Text } from '@doist/marketist'

import { useTranslation } from 'next-i18next'

import css from './Header.module.css'

export function PricingHeader() {
    const { t } = useTranslation('pricing')

    return (
        <Container className={css.pricingHeader}>
            <Image
                src="/assets/pricing/pricing-header.jpg"
                width={600}
                height={321}
                className={css.pricingIllus}
                priority
            />

            <Text tag="h1" size="major-2xl">
                {t('investInBetter')}
            </Text>
        </Container>
    )
}
